"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.is-array");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.map");

require("core-js/modules/es.object.create");

require("core-js/modules/es.object.define-property");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.set-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _native = _interopRequireDefault(require("@emotion/native"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactNative = require("react-native");

var _react = _interopRequireDefault(require("react"));

var _reactNativeModalSelector = _interopRequireDefault(require("react-native-modal-selector"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Input =
/*#__PURE__*/
_native["default"].TextInput(function (_ref) {
  var theme = _ref.theme;
  return {
    borderWidth: 1,
    borderRadius: 2,
    padding: 5,
    margin: 10,
    borderColor: theme.borderColor,
    color: theme.labelColor
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

var SelectType =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SelectType, _React$Component);

  function SelectType() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SelectType);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SelectType)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.getOptions = function (_ref2) {
      var options = _ref2.options;

      if (Array.isArray(options)) {
        return options.map(function (val) {
          return {
            key: val,
            label: val
          };
        });
      }

      return Object.keys(options).map(function (key) {
        return {
          label: key,
          key: options[key]
        };
      });
    };

    return _this;
  }

  _createClass(SelectType, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          knob = _this$props.knob,
          _onChange = _this$props.onChange;
      var options = this.getOptions(knob);
      var active = options.filter(function (_ref3) {
        var key = _ref3.key;
        return knob.value === key;
      })[0];
      var selected = active && active.label;
      return _react["default"].createElement(_reactNative.View, null, _react["default"].createElement(_reactNativeModalSelector["default"], {
        data: options,
        initValue: knob.value,
        onChange: function onChange(option) {
          return _onChange(option.key);
        },
        animationType: "none"
      }, _react["default"].createElement(Input, {
        editable: false,
        value: selected,
        autoCapitalize: "none",
        underlineColorAndroid: "transparent"
      })));
    }
  }]);

  return SelectType;
}(_react["default"].Component);

SelectType.defaultProps = {
  knob: {},
  onChange: function onChange(value) {
    return value;
  }
};
SelectType.propTypes = {
  knob: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    value: _propTypes["default"].string,
    options: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].object]),
    selectV2: _propTypes["default"].bool
  }),
  onChange: _propTypes["default"].func
};

SelectType.serialize = function (value) {
  return value;
};

SelectType.deserialize = function (value) {
  return value;
};

var _default = SelectType;
exports["default"] = _default;